// aнимация главной

import {isMobile, isTablet, isDesktop} from "../../functions/check-viewport";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)


function animSectionOne() {
  const sectionOne = document.getElementById('sectionOne');
  const markers = document.getElementById('marker-scroll');
  const imageBig = document.getElementById('anim__image--1');
  const sectionThree = document.getElementById('sectionThree');
  const sectionTwo = document.getElementById('sectionTwo');
  const animBlock = document.getElementById('anim__block--1');
  const animBlockFix = document.querySelector('.footer__up--right');
  const AnimContOne = document.getElementById('AnimSecOne');
  const AnimContTwo = document.getElementById('AnimSecTwo');
  const messageOne = document.getElementById('message-1');
  const messageTwo = document.getElementById('message-2');
  const messageThree = document.getElementById('message-3');
  const wrapper = document.getElementById('wrapper');
  const main = document.querySelector('.site-container');
  // const content = document.getElementById('content');
  // const sectionTwo = document.getElementById('sectionTwo');


  if (isDesktop() || isTablet()) {

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: AnimContOne,
        pin: true,
        anticipatePin: 30,
        start: 'top top',
        end: () => AnimContOne.offsetWidth * 1.5,
        scrub: 2,
        ease: 'linear',



      },

    })



    tl.fromTo(sectionOne, {y: '0%'}, {y: '-100%'})
    tl.fromTo(imageBig, {scale: '1'}, {scale: '2'}, 0)
    tl.fromTo(animBlock, {y: '200%'}, {y: '0%'})
    tl.fromTo(animBlockFix, {opacity: '0'}, {opacity: '1'})


    function MessageFun() {
      const tb = gsap.timeline({
        scrollTrigger: {
          trigger: AnimContTwo,
          pin: true,
          start: 'top 40%',
          end: 'top 40%',
          ease: 'linear',

        }
      })

      tb.fromTo(messageOne, 0.6, {y: '200%'}, {y: '0%'})
      tb.fromTo(messageTwo, 0.6, {y: '200%'}, {y: '0%'})
      tb.fromTo(messageThree, 0.6, {y: '200%'}, {y: '0%'})


    }
    MessageFun()

  }


}

function animSectionTwo() {
  const AnimContTwo = document.getElementById('AnimSecTwo');
  const messageOne = document.getElementById('message-1');
  const messageTwo = document.getElementById('message-2');
  const messageThree = document.getElementById('message-3');


  if (isMobile()) {
    const tv = gsap.timeline({
      scrollTrigger: {
        trigger: AnimContTwo,
        start: 'top top',
        end: 'top top',
      }
    })
    tv.fromTo(messageOne, {x: '-130%'}, {x: '0%'})
    tv.fromTo(messageTwo, {x: '130%'}, {x: '0%'})
    tv.fromTo(messageThree, {x: '-130%'}, {x: '0%'})
  }


}

function animSectionFour() {

  if (isMobile()) {
    function onEntry(entry) {
      entry.forEach(change => {
        if (change.isIntersecting) {
          change.target.classList.add('true');
        } else {
        }
      });
    }

    let options = {
      threshold: [0.7]
    };
    let observer = new IntersectionObserver(onEntry, options);
    let elements = document.querySelectorAll('.sectionFour__item');

    for (let elm of elements) {
      observer.observe(elm);
    }
  }


}


function animationHome() {

  animSectionOne()
  animSectionTwo()
  animSectionFour()


}

export {
  animationHome
}
